export default {
  getPrintTaskTitle(projectName: string, date: string, subTasksTitle?: string) {
    return `${
      subTasksTitle ? subTasksTitle : 'گام‌های'
    } ${projectName} - ${date}`;
  },
};
